const CATEGORY_ORDER = ["Workplace", "Hospitality", "Residential"];

// Interleave categories so the scroll mixes workplace / hospitality / residential.
export function mixByCategory(items) {
  const buckets = {};
  items.forEach((w) => {
    (buckets[w.cat] ||= []).push(w.src);
  });
  const out = [];
  let added = true;
  while (added) {
    added = false;
    CATEGORY_ORDER.forEach((k) => {
      if (buckets[k]?.length) {
        out.push(buckets[k].shift());
        added = true;
      }
    });
  }
  return out;
}

// Build ordered rows: 1 full-width, then a pair, repeating.
export function buildRows(items) {
  const rows = [];
  let i = 0;
  let full = true;
  while (i < items.length) {
    const imgs = full ? [items[i]] : items.slice(i, i + 2);
    rows.push({ type: full ? "full" : "pair", imgs });
    i += imgs.length;
    full = !full;
  }
  return rows;
}
